/**
 * Фирменная ЭКГ-линия из логотипа «Импульса».
 *  - <EcgLoader>  — индикатор «Claude пишет пост…»: по линии бежит красный импульс, как на мониторе;
 *  - <EcgMark>    — короткий пульс (активный пункт меню);
 *  - <EcgDraw>    — большая линия, прорисовывается один раз (экран входа).
 */
import { useId } from "react";

/** Ритм как в логотипе: ровная линия → высокий зубец → глубокий провал → зубец → ровная линия */
const BEAT = "L36 20 L41 7 L48 31 L53 12 L57 20";
export const ECG_PATH = `M0 20 H30 ${BEAT} H72 L76 20 L79 15 L83 25 L86 20 H120`;

export function EcgLoader({
  size = 56,
  label,
  className = "",
  tone = "red",
}: {
  size?: number;
  label?: string;
  className?: string;
  tone?: "red" | "white";
}) {
  return (
    <span className={`ecg-loader ecg-loader--${tone} ${className}`} role="status" aria-live="polite">
      <svg viewBox="0 0 120 40" width={size} height={(size * 40) / 120} aria-hidden="true">
        <path className="ecg-loader__base" d={ECG_PATH} pathLength={100} />
        <path className="ecg-loader__beam" d={ECG_PATH} pathLength={100} />
      </svg>
      {label ? <span className="ecg-loader__label">{label}</span> : <span className="sr-only">Загрузка</span>}
    </span>
  );
}

export function EcgMark({ className = "" }: { className?: string }) {
  return (
    <svg className={`ecg-mark ${className}`} viewBox="26 4 34 30" width="28" height="12" preserveAspectRatio="none" aria-hidden="true">
      <path d={`M26 20 H30 ${BEAT} H60`} pathLength={100} />
    </svg>
  );
}

/** Длинная линия через всю ширину: несколько ударов, как на мониторе */
export function EcgDraw({ className = "", beats = 3 }: { className?: string; beats?: number }) {
  const id = useId();
  const seg = 160;
  let d = "M0 60";
  for (let i = 0; i < beats; i++) {
    const x = i * seg;
    d += ` H${x + 70} L${x + 80} 60 L${x + 90} 22 L${x + 104} 104 L${x + 114} 38 L${x + 122} 60 H${x + 136} L${x + 142} 60 L${x + 147} 48 L${x + 153} 72 L${x + 157} 60`;
  }
  d += ` H${beats * seg + 40}`;
  return (
    <svg className={`ecg-draw ${className}`} viewBox={`0 0 ${beats * seg + 40} 120`} preserveAspectRatio="none" aria-hidden="true">
      <defs>
        <linearGradient id={`fade-${id}`} x1="0" x2="1" y1="0" y2="0">
          <stop offset="0" stopColor="currentColor" stopOpacity="0" />
          <stop offset="0.12" stopColor="currentColor" stopOpacity="1" />
          <stop offset="1" stopColor="currentColor" stopOpacity="1" />
        </linearGradient>
      </defs>
      <path d={d} pathLength={100} stroke={`url(#fade-${id})`} />
    </svg>
  );
}
